import { makeStyles, Theme, Typography } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, TelegramIcon, TwitterIcon } from 'svgs/social';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CopyinIcon } from 'svgs';
import { FacebookShareButton, LinkedinShareButton, TelegramShareButton, TwitterShareButton } from 'react-share';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    marginLeft: theme.spacing(2),
    width: 20,
    height: 20,
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(4),
      width: 36,
      height: 36,
    },
  },
  margin: {
    marginLeft: theme.spacing(1),
  },
}));

const SocialFeedWidgetComponent: FC = () => {
  const classes = useStyles();
  const link = typeof location !== 'undefined' ? location.href : '';

  const [copySuccess, setCopySuccess] = useState('');
  const copyToClipboard = () => {
    setCopySuccess('Copied!');
    setTimeout(() => {
      setCopySuccess('');
    }, 2000);
  };

  return (
    <>
      <LinkedinShareButton url={link} className={classes.icon}>
        <LinkedinIcon />
      </LinkedinShareButton>
      <FacebookShareButton url={link} className={classes.icon}>
        <FacebookIcon />
      </FacebookShareButton>
      {/*<InstagramIcon className={classes.icon} />*/}
      <TwitterShareButton url={link} className={classes.icon}>
        <TwitterIcon />
      </TwitterShareButton>
      <TelegramShareButton url={link} className={classes.icon}>
        <TelegramIcon />
      </TelegramShareButton>
      <CopyToClipboard text={link}>
        <CopyinIcon className={classes.icon} onClick={copyToClipboard} />
      </CopyToClipboard>
      <Typography variant="subtitle2" color="textSecondary" className={classes.margin}>
        {copySuccess}
      </Typography>
      {/*<InstagramEmbed clientAccessToken={'123|456'} url={'https://instagr.am/p/Zw9o4/'}>*/}
      {/*</InstagramEmbed>*/}
    </>
  );
};

export default SocialFeedWidgetComponent;
